import { formatLastSyncDate } from "@/modules/stochastic/features/shared/utils/formatLastSyncDate";

interface LastSyncInfo {
  finishedAt: string | null;
  status: string | null;
}

interface LastSyncStatusProps {
  lastSync: LastSyncInfo | null;
}

export const LastSyncStatus: React.FC<LastSyncStatusProps> = ({ lastSync }) => {
  if (lastSync?.status === "failed") {
    return (
      <div className="text-sm text-red-600 dark:text-red-400 font-medium">
        Sync failed
      </div>
    );
  }

  if (lastSync?.finishedAt) {
    return (
      <div className="text-sm text-gray-600 dark:text-gray-400">
        Last updated: {formatLastSyncDate(lastSync.finishedAt)}
      </div>
    );
  }

  return null;
};
